import { createContext, useContext } from "react";
import type { ConsoleMe } from "./session";

export const ConsoleMeContext = createContext<ConsoleMe | null>(null);

/** The signed-in staff member. Only available inside the gate. */
export function useConsoleMe(): ConsoleMe {
  const me = useContext(ConsoleMeContext);
  if (!me) throw new Error("useConsoleMe outside ConsoleGate");
  return me;
}
